export const RenderSoundWarning = ({ showAudioPrompt, callStatus, setShowAudioPrompt }) => {
    // Only show prompt if there's an incoming call and audio is blocked
    if (showAudioPrompt && callStatus === "incoming") {
        return (
            <div
                style={{
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffeeba",
                    color: "#856404",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                    fontSize: "12px",
                    maxWidth: "200px",
                    cursor: "pointer",
                    animation: "fadeIn 0.3s ease-out",
                }}
                onClick={() => setShowAudioPrompt(false)}
            >
                Click to enable call sounds 🔊
            </div>
        );
    }
    return null;
};
